import React from 'react';
import { Select } from 'antd';
import countries from '../../assets/countries/countries.json';
import '../../assets/countries/countries.css';
import './styles/style.less';

const Option = Select.Option;
const countriesArray = [];
const getCountryArray = () => {
	for (let i in countries) {
		countriesArray.push({ 'code': i, 'country': countries[i] });
	}
	countriesArray.sort(function(a, b) {
		return a.country.localeCompare(b.country);
	});
};
getCountryArray();

const TypeCountry = ({ title, onChange, className }) => {
	const findCountryCode = (country) => {
		let countryMap = countriesArray.find(v => v.country === country);
		return (countryMap && countryMap.code) || null;
	}
	return (
		<span className={className}>
			<Select
				placeholder={title}
				className='inputStyle'
				showSearch
				onChange={(country) => onChange(findCountryCode(country))}>
				{countriesArray.map((countryMap, i) => {
					return (
						<Option key={i} value={countryMap.country} title={countryMap.code}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<div className='FlagWrapper'>
									<div className='Flag'>
										<div className={`flag small small-${countryMap.code}`}></div>
									</div>
								</div>
								<div>{countryMap.country}</div>
							</div>
						</Option>);
					})
				}
		    </Select>
        </span>
	);
};

export default TypeCountry;


// WEBPACK FOOTER //
// ./src/components/AnswerTypeCountry/TypeCountry.js